import { render, staticRenderFns } from "./CardTransferSwap.vue?vue&type=template&id=618fb4b1"
import script from "./CardTransferSwap.js?vue&type=script&lang=js&external"
export * from "./CardTransferSwap.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports